// extracted by mini-css-extract-plugin
export default {"checkboxRound":"SearchItems_checkboxRound__GGpUG"};